export const translation_bg = {
    heading: "উৎকর্ষ বাংলা | কর্মদিশা",
    subHeading: "পশ্চিমবঙ্গ সোস্যাইটি ফর স্কিল ডেভেলপমেন্ট",
    partnership: "অংশীদারি সংস্থা ",
    poweredBy: "টাটা কমিউনিকেশন দ্বারা চালিত ",
    welcomeText: "আপনার আগ্রহ অনুযায়ী পেশা বুঝে নিন!", 
    mobileNumber: "মোবাইল নম্বর",
    dob: "জন্মতারিখ",
    otp: "ওটিপি পান",
    enterOTP: "OTP লিখুন",
    validateOTP: "OTP যাচাই করুন",
    resendOTP: "আবার OTP পাঠান",
    form_heading: "এবারে শুরু করা যাক! আপনার সম্পর্কে কিছু বলুন",
    firstName: "নাম",
    firstNamePlaceHolder: "আপনার নাম লিখুন",
    lastName: "পদবী",
    lastNamePlaceHolder: "আপনার পদবী লিখুন",
    qualification: "যোগ্যতা",
    gender: "লিঙ্গ",
    pincode: "পিন নং",
    pincodePlaceHolder:"আপনার পিনকোড টি লিখুন",
    village: "গ্রামের নাম",
    villagePlaceHolder:"গ্রামের নাম",
    district: "জেলা",
    districtPlaceHolder: "জেলার নাম",
    districtPinPlaceHolder:"একটি বৈধ পিনকোড প্রদান করুন ",

    mailId: "ই-মেল ",
    mailIdPlaceHolder:"আপনার ইমেল আইডি লিখুন",
    mandatoryFields: "*বাধ্যতামূলক ",
    save: "সেভ করুন / সংরক্ষন করুন",
    mobileInputError: "* ১০ সংখ্যা",
    pincodeInputError: "* ৬ সংখ্যা",
    onlyNumbersError: "* শুধুমাত্র সংখ্যা",
    onlyCharError: "* শুধুমাত্র অক্ষর",
    noSpecialCharError: "* বিশেষ চিহ্ন-র প্রয়োজন নেই",
    mailError: "* ভুল ইমেল আইডি",
    dobError: "* কমপক্ষে ১৬ বছরের অধিক হতে হবে",
    knowHowToPlayGame: "গেমটি শুরু করার আগে, কেমন ভাবে খেলতে হবে জানতে ভিডিওটি দেখুন",
    letsPlayGame: "এবার, গেমটি শুরু করা যাক !",
    confirmDialog: "নিশ্চিত করুন !",
    yes:"হ্যাঁ",
    no:"না",
    invalidCode: "ভুল OTP",
    ok:"ঠিক আছে",
    gamevideoConfirmation: "অনুগ্রহ করে গেমের নির্দেশিকা ভিডিওটি দেখেছেন কিনা নিশ্চিত করুন...হ্যাঁ/না",
    careervideoConfirmation: "আশা করছি আপনি কেরিয়ার রিপোর্ট ভিডিওটি দেখেছেন",
    doYouLikeThis: "আপনি কি এটা পছন্দ করছেন?", 
    like:"হ্যাঁ",
    dislike: "না ",
    mayBe: "হয়তো",
    congratulations: "আপননাকে অভিনন্দন, ",
    lookAtResults: "আপনার ফলাফল-টি এবার দেখে নেওয়া যাক",
    AfterGameMsg: "আপনি ইতিমধ্যেই আপনার কেরিয়ার অ্যাসেসমেন্টটি সম্পন্ন করে ফেলেছেন যা সাজানো হয়েছে আপনার পছন্দের পেশা/কেরিয়ারের ভিত্তিতে। একজন মানুষের নির্দিষ্ট কাজের প্রতি আগ্রহ তার চরিত্রের বহিপ্রকাশ ঘটায়। এখানে জন হল্যান্ড প্রদত্ত একটি থিওরি দেওয়া আছে যা বৃত্তিমূলক পছন্দ অনুসারে একজন মানুষের অন্তত ছ'টি ভিন্ন চরিত্র সম্পর্কে আলোকপাত করে। যা হল্যান্ড কোড নামে পরিচিত। এখন, আপনার উত্তরের উপর ভিত্তি করে দেখে নেওয়া যাক কোন কোডটি আপনার ক্ষেত্রে প্রযোজ্য-",
    watchCareerVideo: "আপনার কেরিয়ার সম্পর্কে বুঝতে ভিডিওটি দেখুন",
    clickHereButton: "এখানে ক্লিক করুন",
    knowMoreAboutMatchingCareers : "আপনার ব্যক্তিত্বের সমকক্ষ কেরিয়ার ইন্টারেস্ট সম্পর্কে জানতে এখনে ক্লিক করুন",
    ThankYouForPlayingGame: "গেমটি খেলার জন্য ধন্যবাদ।",
    understandBetter: "আপনার বিষয়ে আরও জানতে সাহায্য করুন",
    beforeChatBot: "আপনার বিষয়ে আরও জানতে সাহায্য করুন! আপনি আপনার পছন্দের পেশা নির্বাচনের থেকে মাত্র এক কদম দূরে আছেন। আমরা আপনাকে কাছে কিছু বিকল্প রাখছি। আপনি এর মধ্যে থেকে আপনার পছন্দের পেশা নির্বাচন করতে পারেন।",
    clickToStart: "শুরু করুন",
    chatbotHeading: "প্রশ্নের উত্তরগুলি দিয়ে আপনাকে বুঝতে সাহায্য করুন।",
    noCoursesText: "ক্যারিয়ারের বিকল্পগুলি অন্বেষণ করতে দয়া করে লিঙ্কটি অনুসরণ করুন!",
    explore: "এক্সপ্লোর করুন",
    resultText1: " ",
    resultText2: "ব্যক্তিত্বের একজন ব্যক্তি এই সমস্ত পেশাতে নিজেকে প্রস্ফুটিত করতে পারেন.প্রতিটি সেক্টর সম্পর্কে আরও তথ্য জানতে এখানে ক্লিক করুন",
    JobRole : "কাজের ভূমিকা",
    sector: "সেক্টর",
    recommendCounsellor: "আমাদের পরামর্শ, আপনি আমাদের কাউন্সেলর-এর কাছে গিয়ে আপনার রিপোর্ট সম্পর্কে আরও বিস্তারিত ভাবে জানুন।",
    DownloadReport: " রিপোর্ট ডাউনলোড",
    reachToCounsellorButton: "কাউন্সেলিং এর জন্য যোগাযোগ করুন",
    thankYouForCounsellorRequest: "আপনার আবেদনের জন্য ধন্যবাদ। আমাদের কাউন্সেলর আপনার সাথে শীঘ্রই যোগাযোগ করবেন।",
    contactUs1: "যে কোনও ধরনের জিজ্ঞাসার জন্য আমাদের টোল ফ্রি নম্বর",
    csNumber: "1800-419-2112", 
    contactUs2: "এ সকাল ১০.০০ থেকে  ",
    contactUs3: "বিকেল ৫.৩০ এর মধ্যে যোগাযোগ করুন।", 
    askFeedback: "এই গেমটি আপনার কেমন লেগেছে?",
    thankYouForFeedback: "আপনার মূল্যবান মতামতের জন্য ধন্যবাদ!",
    dear : "প্রিয়",
    alertPageResultMsg:"আপনি সমস্ত ধাপ সম্পন্ন করেছেন, আসুন আপনার ফলাফলগুলি দেখে নিই.আপনার প্রতিক্রিয়া উপর ভিত্তি করে আপনার ব্যক্তিত্ব টাইপ/হল্যান্ড কোড -",
    internetError: "দয়া করে অপেক্ষা করুন.সাইট লোড হচ্ছে.",
    confirmReplayOption: "গেমটি আবার খেললে শেষে তুমি একটি নতুন ক্যারিয়ার রিপোর্ট পাবে। তুমি কি আগ্রহী?",
    ReplayGame: "আবার নতুন করে খেলা",
    gameVideo:"Ir2Wp8Gt4bc",
    beforeNameHappyText:"",
    afterNameHappyText:" আপনাকে স্বাগত " ,
    invalidPincode:"একটি বৈধ পিনকোড প্রদান করুন",
    interestedCourse: 'আগ্রহী যোগ্যতা',
    nearestCenter: 'নিকটতম কেন্দ্র'
};

